import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { SERVER_URL } from './ServerConfig'
import axios from 'axios';
import queryString from 'query-string';
import RemunerationList from './RemunerationList';

class Settings extends Component {

    notify = () => {
        toast.success("You profile settings has been updated!", {
            position: toast.POSITION.TOP_CENTER
        });
    };

    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleInstalledPowerChange = this.handleInstalledPowerChange.bind(this);
        this.handleInstalledkWACChange = this.handleInstalledkWACChange.bind(this);
        this.handleRemunerationChange = this.handleRemunerationChange.bind(this);
        this.handleLatChange = this.handleLatChange.bind(this);
        this.handleLongChange = this.handleLongChange.bind(this);
        this.handleVNDRateChange = this.handleVNDRateChange.bind(this);
        this.avatarFileInput = React.createRef();

        let params = queryString.parse(this.props.location.search);
        this.state = {
            isLoading: true,
            station: {},
            previewAvatarUrl: null,
            avatarChange: false,
            params: params
        }
    }

    componentDidMount() {
        this.fetchStation();
    }

    isOwner() {
        let user = this.props.user.payload.user;
        return user.member.mRole === 'owner';
    }

    fetchStation() {
        let user = this.props.user.payload.user;
        let token = this.props.user.payload.token;
        let stationId = this.state.params.station;
        fetch(SERVER_URL + '/v1/stations/' + stationId, {
            headers: {
                'x-access-token': token
            }
        }).then(response => {
            if (response.status === 403) {
                this.props.history.push("/login");
            } else {
                return response.json();
            }
        })
            .then(data => {
                if (data.success) {
                    let station = data.content;
                    this.setState({ isLoading: false, station: station, previewAvatarUrl: station.mAvatar });
                }
            });
    }

    handleSubmit(event) {
        event.preventDefault();

        let formData = new FormData();
        if (this.state.avatarChange) {
            formData.append("avatar", this.avatarFileInput.current.files[0]);
        }

        formData.append("name", this.state.station.mName);
        formData.append("installedPower", this.state.station.mInstalledPower);
        formData.append("installedkWAC", this.state.station.mInstalledkWAC);
        formData.append("remuneration", this.state.station.mRemuneration);
        formData.append("vndRate", this.state.station.mVNDRate);
        if (this.state.station.mLat) {
            formData.append("lat", this.state.station.mLat);
        }

        if (this.state.station.mLong) {
            formData.append("long", this.state.station.mLong);
        }

        axios({
            method: "POST",
            url: SERVER_URL + '/v1/stations/' + this.state.station._id + '/update',
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "multipart/form-data",
                'x-access-token': this.props.user.payload.token
            },
            data: formData
        }).then(response => {
            let data = response.data;
            if (data.success) {
                this.setState({ station: data.content, previewAvatarUrl: data.content.mAvatar, avatarChange: false })
                this.notify();
                this.props.handleUpdateStation(data.content);
            }
        });
    }

    onUploadAvatarClick(e) {
        this.avatarFileInput.current.click();
    }

    onAvatarFileChange(e) {
        const file = this.avatarFileInput.current.files[0];
        this.setState({ avatarChange: true, previewAvatarUrl: URL.createObjectURL(file), isBlocking: true });
    }

    getPreviewImage() {
        if (this.state.avatarChange) {
            return <img className="imgProfile" src={this.state.previewAvatarUrl} />
        } else {
            if (this.state.previewAvatarUrl) {
                return <img className="imgProfile" src={SERVER_URL + "/" + this.state.previewAvatarUrl} />
            }
            return <img className="imgProfile" src="../img/anonymous.png" />;
        }

    }

    handleNameChange(event) {
        let station = this.state.station;
        station.mName = event.target.value;
        this.setState({ station: station });
    }

    handleInstalledPowerChange(event) {
        let station = this.state.station;
        station.mInstalledPower = event.target.value;
        this.setState({ station: station });
    }

    handleInstalledkWACChange(event) {
        let station = this.state.station;
        station.mInstalledkWAC = event.target.value;
        this.setState({ station: station });
    }

    handleRemunerationChange(event) {
        let station = this.state.station;
        station.mRemuneration = event.target.value;
        this.setState({ station: station });
    }

    handleVNDRateChange(event) {
        let station = this.state.station;
        station.mVNDRate = event.target.value;
        this.setState({ station: station });
    }

    handleLatChange(event) {
        let station = this.state.station;
        station.mLat = event.target.value;
        this.setState({ station: station });
    }

    handleLongChange(event) {
        let station = this.state.station;
        station.mLong = event.target.value;
        this.setState({ station: station });
    }

    canPressUpdate() {
        let station = this.state.station;
        return (station.mName && station.mName.length > 0
            && station.mInstalledPower
            && station.mInstalledkWAC
            && station.mRemuneration);
    }

    getRenderSubmitButton() {
        if (this.isOwner()) {
            if (this.canPressUpdate()) {
                return (<button type="submit" className="btn btn-primary" onClick={this.handleSubmit}>Update</button>);
            } else {
                return (<button type="submit" className="btn btn-primary" disabled>Update</button>);
            }
        }
    }

    getRenderUploadButton() {
        if (this.isOwner()) {
            return (
                <div className="ml-4">
                    <button type="button" className="btn btn-sm btn-secondary"
                        onClick={e => this.onUploadAvatarClick(e)}>Upload</button>
                    <input type="file" ref={this.avatarFileInput} className="avatarFileInput"
                        accept="image/*"
                        onChange={e => this.onAvatarFileChange(e)} />
                </div>
            )
        }
    }

    getRenderStationInputName() {
        if (this.isOwner()) {
            return (
                <input type="text" className="form-control" placeholder=""
                    value={this.state.station.mName} onChange={this.handleNameChange} />
            )
        }
        return (<input type="text" className="form-control-plaintext" placeholder=""
            value={this.state.station.mName} readOnly />)
    }

    getRenderStationPowerInstalled() {
        if (this.isOwner()) {
            return (
                <input type="number" min="0" className="form-control"
                    value={this.state.station.mInstalledPower} onChange={this.handleInstalledPowerChange} />
            )
        }
        return (<input type="text" className="form-control-plaintext"
            value={this.state.station.mInstalledPower} readOnly />)
    }

    getRenderStationKWACInstalled() {
        if (this.isOwner()) {
            return (<input type="number" min="0" className="form-control"
                value={this.state.station.mInstalledkWAC} onChange={this.handleInstalledkWACChange} />);
        }
        return (<input type="text" className="form-control-plaintext"
            value={this.state.station.mInstalledkWAC} readOnly />)
    }

    getRenderStationRemuneration() {
        if (this.isOwner()) {
            return (<input type="number" min="0" step="any" className="form-control"
                value={this.state.station.mRemuneration} onChange={this.handleRemunerationChange} />);
        }
        return (<input type="text" className="form-control-plaintext"
            value={this.state.station.mRemuneration} readOnly />)
    }

    getRenderStationVNDRate() {
        if (this.isOwner()) {
            return (<input type="number" min="0" step="any" className="form-control"
                value={this.state.station.mVNDRate} onChange={this.handleVNDRateChange} />);
        }
        return (<input type="text" className="form-control-plaintext"
            value={this.state.station.mVNDRate} readOnly />)
    }

    getRenderStationLatitude() {
        if (this.isOwner()) {
            return (<input type="text" className="form-control"
                value={this.state.station.mLat} onChange={this.handleLatChange} />);
        }
        return (<input type="text" className="form-control-plaintext"
            value={this.state.station.mLat} readOnly />)
    }

    getRenderStationLongtitude() {
        if (this.isOwner()) {
            return (<input type="text" className="form-control"
                value={this.state.station.mLong} onChange={this.handleLongChange} />);
        }
        return (<input type="text" className="form-control-plaintext"
            value={this.state.station.mLong} readOnly />)
    }

    render() {
        if (this.state.isLoading) {
            return (
                <div></div>
            )
        }
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Settings</h1>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="m-2">
                    <section className="content col-sm-9">
                        <div className="card">
                            <div className="card-body">
                                <div className="update-settings">
                                    {this.getRenderSubmitButton()}
                                </div>
                                <form className="form-horizontal" onSubmit={this.handleSubmit}>
                                    <div className="form-group row">
                                        <label htmlFor="inputName" className="col-sm-4 col-form-label">Station Avatar</label>
                                        <div className="text-center d-flex flex-row avatarCardBody">
                                            <div className="imgProfileContainer">
                                                {this.getPreviewImage()}
                                            </div>
                                            {this.getRenderUploadButton()}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="inputName" className="col-sm-4 col-form-label">Station Name</label>
                                        <div className="col-sm-8">
                                            {this.getRenderStationInputName()}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="inputEmail" className="col-sm-4 col-form-label">Installed power (kWp)</label>
                                        <div className="col-sm-8 flex-container">
                                            {this.getRenderStationPowerInstalled()}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label">Installed kWAC</label>
                                        <div className="col-sm-8 flex-container">
                                            {this.getRenderStationKWACInstalled()}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="inputExperience2" className="col-sm-4 col-form-label">Latitude</label>
                                        <div className="col-sm-8">
                                            {this.getRenderStationLatitude()}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="inputExperience3" className="col-sm-4 col-form-label">Longtitude</label>
                                        <div className="col-sm-8">
                                            {this.getRenderStationLongtitude()}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="inputExperience" className="col-sm-4 col-form-label">Currency</label>
                                        <div className="col-sm-8">
                                            {<input type="text" className="form-control-plaintext"
                                                value={this.state.station.mCurrency} readOnly />}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="inputName2" className="col-sm-4 col-form-label">Remuneration per kWh (default)</label>
                                        <div className="col-sm-8">
                                            {this.getRenderStationRemuneration()}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="inputName2" className="col-sm-4 col-form-label">Exchange rate (USD/VND)</label>
                                        <div className="col-sm-8">
                                            {this.getRenderStationVNDRate()}
                                        </div>
                                    </div>
                                    <RemunerationList user={this.props.user} station={this.state.station} />
                                </form>
                            </div>
                        </div>

                    </section>

                </div >
                <ToastContainer position="top-right"
                    autoClose={2000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick />
            </div >

        );

    }
}

export default Settings;